/**
 * Generated from ch3_p02.fla
 */
export function ch3_p02(this: Ich3_p02) {
	const bg = this.bg;
	ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const list = this.list;
	ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_list.call(this.list);
	list.x = 833.5;
	list.y = 395.25;
	list.width = 638.00;
	list.height = 713.50;
	list.alpha = 1.00;
	if (list.onLayout) list.onLayout();
	const frameRight = this.frameRight;
	ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_bg(this: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_list(this: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_list) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p02_list", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeRframe(this: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeLframe(this: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich3_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich3_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich3_p02Sprite extends Ich3_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich3_p02Text extends Ich3_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich3_p02Polygon extends Array<number> {
}
interface Ich3_p02 {
	readonly bg: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_bg;
	readonly list: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_list;
	readonly frameRight: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeRframe;
	readonly frameLeft: Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeLframe;
}
interface Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_bg extends Ich3_p02Sprite {
}
interface Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_list extends Ich3_p02Sprite {
}
interface Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeRframe extends Ich3_p02Sprite {
}
interface Ich3_p02_hh_ch3_72dpi_p02psdAssetchp3_p02_wcframeLframe extends Ich3_p02Sprite {
}
